import { space, colors } from 'nicollet-tokens';
import styled from 'styled-components';
import { ndsFontReset, isValidNumber } from '@nicollet/common';
import { DEGREES_FROM_SIDE_STRING, OPPOSITES } from './constants.js';
import { TriangleSvg } from './TriangleSvg.js';

const StyledTriangleSvg = styled(TriangleSvg)`
  transform: rotate(${props => DEGREES_FROM_SIDE_STRING[props.side] || 0}deg);
  width: ${props => props.width}px;
  height: ${props => props.width / 2}px;
  display: block;
  ${props => !props.isBackTriangle ? 'position: relative' : ''};
  ${props => props.isBackTriangle && props.shadow ? `filter: drop-shadow(${props.shadow})` : ''};
  outline: none;
`;
const TriangleClippingDiv = styled.div`
  position: absolute;
  ${props => props.shadow ? `margin-bottom: -${space.generic.x1}` : ''};
  ${props => props.shadow ? `padding-bottom: ${space.generic.x1}` : ''};
  ${props => OPPOSITES[props.side]}: 1px;
  ${props => ['top', 'bottom'].includes(props.side) ? 'overflow-y: hidden' : ''};
  pointer-events: none;
`;
const TailWrapper = styled.div`
  position: absolute;
  ${({
  side,
  width
}) => {
  const isVertical = side === 'top' || side === 'bottom';
  const tailSize = isVertical ? width * 0.5 : width * 0.75;
  return `${side}: ${-1 * (tailSize - 1)}px;`;
}}
  ${({
  offsetSide,
  offset
}) => `${offsetSide}: ${offset};`}
`;
const padding = Number.parseInt(space.generic.x2, 10);
const BORDER_RADIUS = 4;
const BORDER_WIDTH = 1;
const DismissibleDiv = styled.div`
  position: absolute;
  top: ${space.generic.x2};
  right: ${space.generic.x2};
`;
const DismissButton = styled.button`
  vertical-align: middle;
  padding: 0;
  border: none;
  background-color: transparent;
  margin: 0;
  cursor: pointer;
  &:focus {
    outline: ${colors.text.formLabel} dashed 1px;
    outline-offset: 2px;
    -moz-outline-radius: 4px;
  }
`;

const setMarginRule = (side, height) => `margin-${side}: calc(${height}px + 3px);`;

const setPaddingValue = isDismissible => isDismissible ? `${padding - 1}px ${padding + 40}px ${padding + 1}px ${padding}px` : `${padding - 1}px ${padding}px ${padding + 1}px`;

const SpeechBubbleContent = styled.div`
  ${({
  textAlign
}) => ndsFontReset({
  textAlign
})};
  ${({
  inline
}) => inline && 'display: inline-block;'}
  max-width: ${({
  containerFluid,
  maxWidth
}) => containerFluid ? 'none' : maxWidth};
  padding: ${({
  containerFluid,
  isDismissible
}) => containerFluid ? '0' : setPaddingValue(isDismissible)};
  position: relative;
  border-radius: ${BORDER_RADIUS}px;
  background-color: ${({
  backgroundColor
}) => backgroundColor};
  color: ${({
  color
}) => color};
  border: ${BORDER_WIDTH}px solid ${({
  borderColor
}) => borderColor};
  ${({
  tailSide,
  tailHeight
}) => setMarginRule(tailSide, tailHeight)}
  word-wrap: break-word;
  ${({
  zIndex
}) => isValidNumber(zIndex) && `z-index: ${zIndex};`}
  ${({
  shadow
}) => shadow && `box-shadow: ${shadow};`}

  [role='tooltip'] {
    padding: ${({
  containerFluid
}) => containerFluid ? '0 !important' : 'inherit'};
  }
`;

export { BORDER_RADIUS, BORDER_WIDTH, DismissButton, DismissibleDiv, SpeechBubbleContent, StyledTriangleSvg, TailWrapper, TriangleClippingDiv, padding };
